const environments = [
  "local",
  "development",
  "test",
  "acceptance",
  "production",
];

module.exports = environments;
